import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import { FlexColumn, FlexRow } from '../../../components/atoms/layout/Flex'
import Button from '../../../components/atoms/inputs/Button'
import VisitorRegistrationSubcontractorTable from '../../../components/organisms/visitor/registration/subcontractor/Table'
import { CompanySelectors } from '../../../store/company/selectors'
import { CompanyActions } from '../../../store/company'
import Alert from '../../../components/atoms/feedback/Alert'
import { useVisitorRegistrationFormSubcontractorCreateDialog } from '../../../hooks/useDialog'

export default function VisitorRegistrationSubcontractorsPage() {
  const dispatch = useDispatch()
  const form = useSelector(CompanySelectors.visitorRegistrationForm)
  const subcontractors = useSelector(CompanySelectors.visitorRegistrationFormSubcontractors)
  const createDialog = useVisitorRegistrationFormSubcontractorCreateDialog()

  useEffect(() => {
    dispatch(CompanyActions.fetchVisitorRegistrationForm())
    dispatch(CompanyActions.fetchVisitorRegistrationFormSubcontractors())
  }, [dispatch])

  if (!form) {
    return (
      <FlexColumn>
        <Alert severity="error">事業者情報を設定してください</Alert>
      </FlexColumn>
    )
  }

  return (
    <FlexColumn>
      <FlexRow>
        <Button onClick={() => createDialog.open()}>新規登録</Button>
      </FlexRow>
      {subcontractors.length === 0 ? (
        <Alert severity="info">下請け情報は登録されていません</Alert>
      ) : (
        <VisitorRegistrationSubcontractorTable subcontractors={subcontractors} />
      )}
    </FlexColumn>
  )
}
